var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#101010",
    stroke: "url(#paint0_linear_5781_3358)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5781_3358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8066 12.24C17.7363 12.0412 17.6062 11.8691 17.4341 11.7473C17.262 11.6256 17.0564 11.5601 16.8456 11.56H16.0556C15.832 11.5612 15.6166 11.6446 15.4506 11.7945C15.2846 11.9443 15.1796 12.15 15.1556 12.3723C15.1317 12.5947 15.1904 12.818 15.3206 12.9998C15.4508 13.1816 15.6434 13.3091 15.8616 13.358L17.0636 13.621C17.3089 13.6751 17.5255 13.8179 17.6721 14.0219C17.8186 14.226 17.8847 14.4769 17.8577 14.7266C17.8307 14.9764 17.7125 15.2074 17.5257 15.3754C17.3389 15.5433 17.0968 15.6365 16.8456 15.637H16.1656C15.9547 15.6368 15.7492 15.5714 15.5771 15.4496C15.405 15.3278 15.2748 15.1557 15.2046 14.957M16.5056 11.56V10.54M16.5056 16.656V15.636",
    stroke: "#FFD521",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20364 14.134C8.70948 15.0444 8.51719 16.0881 8.65447 17.1149C8.79176 18.1416 9.25153 19.0982 9.96751 19.8467C10.6835 20.5953 11.6187 21.0972 12.6383 21.28C13.6579 21.4628 14.7092 21.3171 15.6406 20.864M11.6146 13.598C11.6146 14.8951 12.1299 16.1392 13.0472 17.0564C13.9644 17.9737 15.2085 18.489 16.5056 18.489C17.8028 18.489 19.0469 17.9737 19.9641 17.0564C20.8813 16.1392 21.3966 14.8951 21.3966 13.598C21.3966 12.3008 20.8813 11.0568 19.9641 10.1395C19.0469 9.22227 17.8028 8.70697 16.5056 8.70697C15.2085 8.70697 13.9644 9.22227 13.0472 10.1395C12.1299 11.0568 11.6146 12.3008 11.6146 13.598Z",
    stroke: "#FFD521",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5781_3358",
    x1: 0,
    y1: 0,
    x2: 24,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5781_3358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum);
export default __webpack_public_path__ + "static/media/sum.4583ddb0f11066211eb55ea340c4a16b.svg";
export { ForwardRef as ReactComponent };